<template>
<div class="customer">
    <v-container class="pt-0 ">
        <!-- <div v-for="(item, index) in getClubView" :key="index">
            <p>{{item}}</p>
            <p>{{index}}</p>
        </div> -->
        <v-toolbar class=" mt-5" flat color="white">
            <v-btn icon to="/customers">
                <v-icon class="textColor">keyboard_backspace</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title class="textColor display-1">{{customer.club_name}}</v-toolbar-title>
            <v-spacer></v-spacer>

                <v-icon small class="mr-3" @click="editClub(id)" color="blue">edit</v-icon>

        </v-toolbar>

        <div class="py-3">
            <v-card class="pa-2">
                <v-layout row wrap>
                    <v-flex xs2 class="pa-4">
                        <v-img :src="customer.club_logo" />
                    </v-flex>
                    <v-flex xs8 class="text-capitalize clubView" style="margin-top: auto;margin-bottom: auto;">
                        <!-- <label>Club Name  : </label>
                        <span > {{getClubView.name}}</span><br> -->
                        <label>Admin Name  : </label>
                        <span class="text-capitalize ">  {{customer.user.name}}</span><br>
                        <label>Email : </label>
                        <span class="text-lowercase">{{customer.club_email}}</span><br>
                        <label>Club Phone Number : </label>
                        <span class="text-lowercase">{{customer.club_phone}}</span><br>
                        <!-- <label>description : </label>
                        <span class="body-2"  style="text-align:justify" v-text="getClubView.user.description"></span> -->
                    <!-- </v-flex>
                     <v-flex xs4 class="text-capitalize" > -->
                        <label>status : </label>
                        <span class="text-capitalize "> {{customer.status}}</span><br>
                        <span ></span><br>
                        <!-- <label>Email : </label>
                        <span class="">{{getClubView.user.email}}</span><br>
                        <span class="body-2"  style="text-align:justify" v-text="getClubView.user.description"></span> -->
                    </v-flex>
                    <v-flex xs2 style="margin-top: auto;margin-bottom: auto; margin:auto">
                        <span class="title py-5">{{customer.admin_package.name}}</span>
                        <span class="display-1 py-5 font-weight-bold">{{customer.admin_package.cost}}</span>

                        </v-flex>
                </v-layout>
            </v-card>
        </div>
    </v-container>
</div>
</template>

<script>
/* eslint-disable */
  import { mapState, dispatch } from 'vuex'

export default {
    props:['id'],
    name: "Customer",
    data: () => ({
        clubImg: "https://bootdey.com/img/Content/avatar/avatar7.png",
        selected1:[],
        selected2:[],
        headers1:[
            {text:"Section",value:'section'},
            {text:"Date",value:'date'},
            {text:"Amount",value:'amount'}
        ],
        headers2:[
            {text:"Date",value:'date'},
            {text:"Transection ID",value:'transectionId'},
            {text:"Invoice Amount",value:'invoiceAmount'},
            {text:"Status",value:'status'}
        ],
        table1:[],
        table2:[]


    }),
    computed:{
        ...mapState({

        customer: 'customer',
        loading: 'loading',
        mode: 'mode'
      }),
    },
    created(){
       Store.dispatch('getCustomerById', this.id)
    },
    beforeCreate(){
    },
    methods:{
        editClub(id){
            this.$router.push("/editcustomer/" + id);
        }

    }
}
</script>



// WEBPACK FOOTER //
// src/pages/pages/customers/Customer.vue